import * as Models from "../Models";
// import store from "../";
import axios, { AxiosResponse, AxiosError } from "axios";
import * as msal from "@azure/msal-browser";
import msalConfig from "../Configs/msalConfig";
import * as authService from "../Configs/authService";
import {
  AuthenticationResult,
  BrowserAuthError,
  Configuration,
  EventMessage,
  EventType,
  InteractionRequiredAuthError,
  LogLevel,
} from "@azure/msal-browser";
import azureStore from "../Store/azureStore";

declare var window: any;

axios.defaults.headers["Cache-Control"] = "no-store, no-cache, must-revalidate";
axios.defaults.headers["If-Modified-Since"] = "0";
axios.defaults.headers["X-Requested-With"] = "XMLHttpRequest";
axios.defaults.headers.Accept = "application/json;odata.metadata=full";

const { instance, tenant, clientId, cacheLocation, redirectUri } = msalConfig;

var config: Configuration = {
  auth: {
    clientId,
    authority: instance + tenant,
    redirectUri,
  },
  cache: {
    cacheLocation,
    storeAuthStateInCookie: true,
  },
  system: {
    tokenRenewalOffsetSeconds: 300, //renews the token 5min before exipiring
    loggerOptions: {
      logLevel: LogLevel.Warning,
      piiLoggingEnabled: false,
    },
  },
};

export const msalInstance = new msal.PublicClientApplication(config);

export const initMsal: Function = (): void => {
  msalInstance.addEventCallback(async (event: EventMessage) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
      // Handle login success payload
      const payload = event.payload as AuthenticationResult;
      const account = payload.account;
      msalInstance.setActiveAccount(account);
      // Redirect to original page, or home
      const localUrl = window.sessionStorage.getItem("local-url") || "/";
      window.sessionStorage.removeItem("local-url");
      window.location.assign(localUrl);
    }
  });
};

axios.interceptors.request.use(
  async (config) => {
    const request: Models.AzureRequest = {
      url: config.url,
      started: new Date(),
      critical: true,
    };

    // store.dispatch(AzureActions.requestAdd(request));
    if (request.url) azureStore.getState().requestAdd(request);

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response: AxiosResponse) => {
    const request: Models.AzureRequest = {
      url: response.config.url,
    };

    // store.dispatch(AzureActions.requestRemove(request));
    azureStore.getState().requestRemove(request);

    return response;
  },
  async (error: AxiosError) => {
    const request: Models.AzureRequest = {
      url: error.response.config.url,
    };

    //backup plan, redirects to frontpage to launch login and sets local-url that will be used in intialized section
    // if(error.response?.status == 401) {
    //   window.sessionStorage.setItem('local-url', window.location.origin)
    //   window.location.assign('/');
    // }

    // store.dispatch(AzureActions.requestRemove(request));
    azureStore.getState().requestRemove(request);

    return Promise.reject(error);
  }
);

export const setMarketAreaHeader: Function = (
  marketAreaSettings: Models.MarketAreaSettings
) => {
  if (
    marketAreaSettings.activeMarketArea === "" ||
    marketAreaSettings.userMode === undefined
  ) {
    axios.defaults.headers.common["Outotec-marketArea"] = "";
    delete axios.defaults.headers.common["Outotec-marketArea"];
    return false;
  } else {
    axios.defaults.headers.common[
      "Outotec-marketArea"
    ] = `${marketAreaSettings.activeMarketArea}:${marketAreaSettings.userMode}`;
    return true;
  }
};

axios.interceptors.request.use(async (config) => {
  const token = await authService.fetchServiceTokenAsync();
  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  return config;
});

export default axios;
